<div class="chart-wrapper" > 
    <div #chartDiv style="width:100%; height:100%;"></div>
</div>
